<div class="dialog-header">
    <span>EAGLE-I™ Feedback</span>
    <fa-icon icon="times" (click)="dialogRef.close()"></fa-icon>
</div>

<div #content class="dialog-content">
    <form [formGroup]="feedbackForm">
        <mat-form-field>
            <mat-label>Feedback Type</mat-label>
            <mat-select required formControlName="feedbackType">
                <mat-option value="training">Request Application Training</mat-option>
                <mat-option value="feedback">Feedback</mat-option>
                <mat-option value="feature">Feature Request</mat-option>
                <mat-option value="bug">Bug</mat-option>
            </mat-select>
            <mat-error>Feedback Type is required</mat-error>
        </mat-form-field>

        <mat-form-field>
            <mat-label>Feedback Summary</mat-label>
            <input matInput required formControlName="summary" />
            <mat-error>Summary is required</mat-error>
        </mat-form-field>

        <mat-form-field>
            <mat-label>Feedback Description </mat-label>
            <textarea matInput formControlName="description" cdkTextareaAutosize cdkAutosizeMaxRows="5" cdkAutosizeMinRows="5"></textarea>
            <mat-error>Description is required</mat-error>
        </mat-form-field>
    </form>
</div>

<div class="dialog-actions">
    <button mat-flat-button (click)="submitFeedback()" color="primary" [disabled]="feedbackForm.invalid">Submit</button>
</div>
